<mas-retail-header></mas-retail-header>
<div class="overall-body-style">
  <ng-container>
    <router-outlet></router-outlet>
    <mas-retail-footer></mas-retail-footer>
  </ng-container>
</div>
